var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBtnFullReflex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "play_btn_full_reflex_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: ".6in",
    height: ".6in",
    viewBox: "0 0 45 45"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#001464"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 21.7c.6.4.6 1.2 0 1.6l-11.5 8.3a1 1 0 01-1.6-.8V14.2c0-.8.9-1.3 1.6-.8l11.5 8.3z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIuNmluIiBoZWlnaHQ9Ii42aW4iIHZpZXdCb3g9IjAgMCA0NSA0NSI+PGNpcmNsZSBjeD0iMjIuNSIgY3k9IjIyLjUiIHI9IjIyLjUiIHN0eWxlPSJmaWxsOiMwMDE0NjQ7Ii8+PHBhdGggZD0iTTMwLjgsMjEuN2MuNi40LjYsMS4yLDAsMS42bC0xMS41LDguM2MtLjcuNS0xLjYsMC0xLjYtLjhWMTQuMmMwLS44LjktMS4zLDEuNi0uOGwxMS41LDguM1oiIHN0eWxlPSJmaWxsOiNmZmY7Ii8+PC9zdmc+";
export { SvgPlayBtnFullReflex as ReactComponent };